import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import wikiSystemInfoComponent from '@/components/wiki/page/systemInfo.vue'
import wikiTextComponent from '@/components/wiki/page/text.vue'
import wikiQrComponent from '@/components/wiki/page/qrcode.vue'

const wikitActiveInfoPage: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['systemInfo', 'qrcode'], ['text']],
    xs: [['text', 'systemInfo', 'qrcode']]
  },
  blocks: {
    systemInfo: {
      block: wikiSystemInfoComponent,
      options: {}
    },
    text: {
      block: wikiTextComponent,
      options: {}
    },
    qrcode: {
      block: wikiQrComponent,
      options: {}
    }
  }
}
export default wikitActiveInfoPage